import {
  PencilSquareIcon,
  PhoneIcon,
} from '@heroicons/react/24/outline';
import { CallActivity } from './types';
import { OUTCOME_LABELS, formatRdvDate, formatShortDateTime } from './crmShared';

const OUTCOME_DOT: Record<string, string> = {
  rdv_pris: 'bg-blue-500',
  a_rappeler: 'bg-amber-500',
  no_answer: 'bg-gray-400',
  pas_interesse: 'bg-red-500',
};

function callerLabel(activity: CallActivity): string {
  return activity.caller?.name ?? activity.caller?.email ?? 'Conseiller';
}

export function CallActivityList({ activities }: { activities: CallActivity[] }) {
  if (!activities.length) {
    return <p className="text-sm text-gray-500">Aucun appel enregistré pour l’instant.</p>;
  }

  return (
    <ol className="space-y-3">
      {activities.map((activity) => {
        const isEdit = activity.type === 'edit';
        const outcome = activity.outcome ?? '';
        return (
          <li key={activity.id} className="flex gap-3">
            <div className="mt-0.5 shrink-0">
              {isEdit ? (
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-violet-100 text-violet-600">
                  <PencilSquareIcon className="h-4 w-4" aria-hidden="true" />
                </span>
              ) : (
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-gray-100 text-gray-600">
                  <PhoneIcon className="h-4 w-4" aria-hidden="true" />
                </span>
              )}
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
                {isEdit ? (
                  <span className="text-sm font-semibold text-gray-900">Coordonnées modifiées</span>
                ) : (
                  <span className="flex items-center gap-1.5 text-sm font-semibold text-gray-900">
                    <span className={`h-2 w-2 rounded-full ${OUTCOME_DOT[outcome] ?? 'bg-gray-400'}`} aria-hidden="true" />
                    {OUTCOME_LABELS[outcome] ?? outcome}
                  </span>
                )}
                <span className="text-xs text-gray-400">·</span>
                <span className="text-xs text-gray-500">{callerLabel(activity)}</span>
                <span className="text-xs text-gray-400">·</span>
                <span className="text-xs text-gray-500">{formatShortDateTime(activity.createdAt)}</span>
              </div>
              {activity.note && <p className="mt-0.5 break-words text-sm text-gray-700">{activity.note}</p>}
              {activity.callbackAt && (
                <p className="mt-0.5 text-xs text-amber-700">Rappel prévu : {formatShortDateTime(activity.callbackAt)}</p>
              )}
              {activity.rdvDate && (
                <p className="mt-0.5 text-xs text-blue-700">
                  RDV : {formatRdvDate(activity.rdvDate)}
                  {activity.rdvHeure ? ` à ${activity.rdvHeure}` : ''}
                </p>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
